module.exports = "/images/progress-form.png?03884392de5aa98b7505d6999a82e4ee";